import cx from 'classnames'
import { KeyboardEvent, useEffect } from 'react'
import { CloseButton } from 'components/Buttons/CloseButton'
import { AnimateSlideInOut } from './AnimateSlideInOut'
import Styles from './Sidebar.module.scss'
import { SidebarProps } from './Types'

const Sidebar = ({ open, onClose, heading, children, rootOverrideClassName }: SidebarProps) => {
  useEffect(() => {
    const handleEscape = (event: KeyboardEvent) => {
      if (event.key === 'Escape') {
        onClose()
      }
    }
    // @ts-ignore
    document.addEventListener('keydown', handleEscape, false)
    return () => {
      // @ts-ignore
      document.removeEventListener('keydown', handleEscape, false)
    }
  }, [onClose])

  return (
    <AnimateSlideInOut in={open}>
      <div className={cx(Styles.root, rootOverrideClassName)}>
        <div className={Styles.header}>
          {heading}
          <CloseButton size="sm" onClick={onClose} color="gray" className={Styles.closeButton} />
        </div>
        {children}
      </div>
    </AnimateSlideInOut>
  )
}

export { Sidebar }
